import apiClient, { jsonRequestConfig } from "./httpClient";
import endpoints from "./endpoints";

export const devicesApi = {
  filtered: (organizationId, params = {}) => apiClient.get(endpoints.device.filtered(organizationId), { params }),
  filteredSseUrl: (organizationId, params = {}) => endpoints.device.filteredSse(organizationId, params),
  getSseUrl: (deviceId) => endpoints.device.getSse(deviceId),
  planAction: (deviceId, payload) =>
    apiClient.post(endpoints.device.planAction(deviceId), payload, jsonRequestConfig),
  planRequest: (deviceId, payload) =>
    apiClient.post(endpoints.device.planRequest(deviceId), payload, jsonRequestConfig),
  delete: (deviceId) => apiClient.delete(endpoints.device.delete(deviceId)),
  deleteMany: (ids) => apiClient.post(endpoints.device.deleteMany(), ids, jsonRequestConfig),
  deleteImpact: (ids) => apiClient.post(endpoints.device.deleteImpact(), ids, jsonRequestConfig),
  deleteData: (body) => apiClient.post(endpoints.data.delete(), body, jsonRequestConfig),
};

export default devicesApi;
